import { Button, Table } from "antd";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useHistory } from "react-router-dom";
import { TableComponentProps, TableData } from "@components/table/tableContainer";
import Column from "antd/lib/table/Column";
import { CheckCircleFilled, CloseCircleFilled, ClockCircleFilled } from "@ant-design/icons";

interface OrderedArticlesMapped {
    articleId: string;
    articleTitle: string;
    articleAmount: number;
}

export interface OrdersTableData extends TableData {
    id: string;
    userId: string;
    userEmail: string;
    orderedArticles: OrderedArticlesMapped[];

}

export interface OrdersTableProps extends TableComponentProps {
    dataSource: OrdersTableData[];
}

export const OrdersTable: React.FC<OrdersTableProps> = ({ ...tableProps }) => {
    const history = useHistory();
    const renderUserEmail = (text: string, id: string) => (
        <Link
            className="plainText"
            to={`/users/detail/${id}`}
        >
            {text}
        </Link>
    );

    const renderArticleTitle = (articles: OrderedArticlesMapped[]) => (
        <React.Fragment>
            {articles.map((article, index) => (
                <React.Fragment>
                    <Link
                        className="plainText"
                        to={`/articles/edit/${article.articleId}/general`}
                    >
                        {article.articleTitle}
                    </Link>
                    {index !== (articles.length - 1) && <span>, </span>}
                </React.Fragment>

            ))}
        </React.Fragment>
    );

    return (
        <Table
            pagination={{ showSizeChanger: true, showQuickJumper: true }}
            rowKey="id"
            {...tableProps}
        >
            <Column
                key="userEmail"
                dataIndex="userEmail"
                render={(text, row: OrdersTableData) => renderUserEmail(text, row.userId)}
                title={<FormattedMessage id="user" />}
                width={200}
            />
            <Column
                key="orderedArticles"
                dataIndex="orderedArticles"
                render={(text, row: OrdersTableData) => renderArticleTitle(row.orderedArticles)}
                title={<FormattedMessage id="orderedArticles" />}
                width={200}
            />
            <Column
                key="actions"
                render={(text, row: OrdersTableData) => (
                    <Button
                        type="primary"
                        onClick={() => history.push(`/orders/detail/${row.id}`)}
                    >
                        <FormattedMessage id="Open" />
                    </Button>
                )}
                title={<FormattedMessage id="empty" />}
                width={100}
            />
            <Column
                key="hasPendingArticle"
                render={({
                    orderedArticles
                }) => {
                    console.log(orderedArticles);

                    // eslint-disable-next-line no-nested-ternary
                    return orderedArticles.some(oa => oa.status === "pending") ? (
                        <ClockCircleFilled
                            className="notPublishedYet"
                        />
                    ) : (orderedArticles.some(oa => oa.status === "rejected")
                        ? <CloseCircleFilled className="red" />
                        : <CheckCircleFilled className="green" />);
                }}
                title={<FormattedMessage id="order.article.hasPendingArticle" />}
                width={50}
            />
        </Table>
    );
};
